function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "layer-1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "252.99 246.08 246.4 371.55 162.91 367.17 163.61 353.87 169.5 241.69 222.07 244.45 252.99 246.08",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.51 336.04 116.96 358.43 83.32 237.36 116.67 228.09 163.87 214.98 194.39 324.82 197.51 336.04",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75H407a5.08,5.08,0,0,1,5.43,4.71A5.15,5.15,0,0,1,412.16,275.05Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.15,363v8.24H287.23V363a6.06,6.06,0,0,1,6.06-6.06h77.79a6.05,6.05,0,0,1,6.07,6.06Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.31,369c-4.31,4.39,16.58,73.37,16.58,73.37-2.28,2-5.64,2.92-8.82,3.34a40.55,40.55,0,0,1-8.81.13s-29.94-72.62-21.7-90.64S320.93,329,320.93,329l2.18-5.4,26.45-3.72,4.37,32.39s-4.34.42-10.87,1.26C325.55,355.75,292.23,361,284.31,369Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.36,277.39a18.39,18.39,0,0,1-1-7.43,21.83,21.83,0,0,1,.27-2.55l-1.69-2.68-2.17-3.45,2.51-10s16,3.08,17.2,7.54S324.36,277.39,324.36,277.39Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.33,259.88c-.05-76.49,11.45-96.74-30-161.36s-143.06-78.93-219.9-31-97.5,109.57-97.5,109.57-27.88,72,11.3,144.5c35.83,66.32,106.39,104,167.59,135H403.31a110.3,110.3,0,0,0,23.92-28.3C459.1,374.66,415.39,336.37,415.33,259.88Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.33,259.88c-.05-76.49,11.45-96.74-30-161.36s-143.06-78.93-219.9-31-97.5,109.57-97.5,109.57-27.88,72,11.3,144.5c35.83,66.32,106.39,104,167.59,135H403.31a110.3,110.3,0,0,0,23.92-28.3C459.1,374.66,415.39,336.37,415.33,259.88Z",
    style: {
      fill: "#fff",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "279.93 308.37 320.21 456.95 326.23 456.95 285.96 308.37 279.93 308.37",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.3,
    y: 414.83,
    width: 76.35,
    height: 6.22,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,275,362.05,457h-6l49.32-182c1.82-6.71-2.35-12.17-9.3-12.17h-42.5c-6.94,0-14.08,5.46-15.9,12.17L288.33,457h-6l49.33-182c2.69-9.93,13.21-18,23.49-18h42.51C407.91,257,414.07,265.06,411.38,275Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75H407a5.08,5.08,0,0,1,5.43,4.71A5.15,5.15,0,0,1,412.16,275.05Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75h36.11c15.61,16,13.62,45.49,12.6,54.39a9.74,9.74,0,0,0,7-6.52L405.1,271a6.11,6.11,0,0,0,.15-2.69H407a5.08,5.08,0,0,1,5.16,6.74Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75H407a5.08,5.08,0,0,1,5.43,4.71A5.15,5.15,0,0,1,412.16,275.05Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.1 372.71 393.94 456.95 399.96 456.95 377.13 372.71 371.1 372.71",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.15,363v8.24H287.23V363a6.06,6.06,0,0,1,6.06-6.06h77.79a6.05,6.05,0,0,1,6.07,6.06Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.94,361.45c-2.91,3.42-8.13,6.9-17.11,9.83h-72.6V363a6.06,6.06,0,0,1,6.06-6.06h77.79A6.07,6.07,0,0,1,376.94,361.45Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.15,363v8.24H287.23V363a6.06,6.06,0,0,1,6.06-6.06h77.79a6.05,6.05,0,0,1,6.07,6.06Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.25,
    y: 368.75,
    width: 98.66,
    height: 7.73,
    rx: 1.71,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.31,369c-4.31,4.39,16.58,73.37,16.58,73.37-2.28,2-5.64,2.92-8.82,3.34a40.55,40.55,0,0,1-8.81.13s-29.94-72.62-21.7-90.64S320.93,329,320.93,329l2.18-5.4,26.45-3.72,4.37,32.39s-4.34.42-10.87,1.26C325.55,355.75,292.23,361,284.31,369Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.89,442.41c-2.28,2-5.64,2.92-8.82,3.34-5.81-21.6-20.6-79.24-15-86.29,6.91-8.7,41.11-16.61,41.11-16.61.14-4.44,12.13-8.44,12.13-8.44l12.74,19.09C325.54,355.75,292.22,361,284.3,369,280,373.43,300.89,442.41,300.89,442.41Z",
    style: {
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.31,369c-4.31,4.39,16.58,73.37,16.58,73.37-2.28,2-5.64,2.92-8.82,3.34a40.55,40.55,0,0,1-8.81.13s-29.94-72.62-21.7-90.64S320.93,329,320.93,329l2.18-5.4,26.45-3.72,4.37,32.39s-4.34.42-10.87,1.26C325.55,355.75,292.23,361,284.31,369Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,292.19s6.55,1.63,8.56,3,1.43,6.32,1.43,6.32S276.26,299.05,275,292.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.82 279.64 283 303 284.44 303 272.87 278.49 270.82 279.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.8,296.53s-7.68-5.46-9.56-5.46-7.51,6.65-7.51,10,12.28,5.18,14.68,2.35c1.2-1.41-1.18-4.81-1.18-4.81a45,45,0,0,0,4.59,4.25c1,.56,2.91-.17,2.91-.17S283.17,298.59,281.8,296.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,304.19a23.06,23.06,0,0,0-6.41-5.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,298.59s-2.66-2.32-4.45-2.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,301.54a47.09,47.09,0,0,1,5.37,3.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,263.58c-3.93,2.74-21.58,20.89-21.58,20.89s8.27,9.41,15.52,10.77l19.65-9.54Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,263.58c-3.93,2.74-21.58,20.89-21.58,20.89s8.27,9.41,15.52,10.77l19.65-9.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.51,445.57s1.78,8.51,0,14.84c0,0-26.51,4.15-32.44,2.57s-9.53-4.54-9.71-6c0,0,.21-4.06,6.15-5.25s17.75-2,22.42-8.7S293.51,445.57,293.51,445.57Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.49,322.72c8.47-12.08,47.41,2.46,47.41,2.46s3.71,29.08-11.8,36.84-37.87,7.34-43.91,13.63l-24.58,72.58s-8.83,3.69-21.67-2.12c0,0,15.61-54.81,20.19-74.27,4.53-19.26,33.86-32.33,33.86-32.33a17.81,17.81,0,0,1-3.37-6.08",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.91,350.52A43,43,0,0,1,364,353.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,325.89c3.18,6.9,3.43,15.66-1,22.05",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,327s-.81,5.32,1.56,7.43,9.64,3.18,9.64,3.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.31,327.24s.33,5.3-1.82,5.05-2.26,2.12-2.26,2.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68,267.66a18.1,18.1,0,0,1-.52-4.08s12-10.12,27.45-10.06c18.4.06,29.65,5.85,34.15,13.89,7.14,12.72,8.14,57.77,8.14,57.77s-46.17,7.12-52.79-1.61c-1.15-1.52-.27-12.25-.27-12.25s-5.17-13.56-6.26-24.08a76.45,76.45,0,0,1-4.23-6.5,61,61,0,0,1-4.26-8.61",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68,267.66a18.1,18.1,0,0,1-.52-4.08s12-10.12,27.45-10.06c18.4.06,29.65,5.85,34.15,13.89,7.14,12.72,8.14,57.77,8.14,57.77s-46.17,7.12-52.79-1.61c-1.15-1.52-.27-12.25-.27-12.25s-5.17-13.56-6.26-24.08a76.45,76.45,0,0,1-4.23-6.5,61,61,0,0,1-4.26-8.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,278.49s7.05,27.35,6,33.37a11,11,0,0,0,1,6.07,6.36,6.36,0,0,0-1,7.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.06,301.12a7,7,0,0,1-3.54-1.12l-2.09-9.16a38.74,38.74,0,0,0,12.38-.87l2.24,10a33.5,33.5,0,0,1-3.83.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.35,282.05s-6-25.56,9.14-28.53,18.25,4.1,17.36,8.89c-1.19,6.39-13.74,22.06-13.74,22.06l-7.75-6Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.35,282.05s-6-25.56,9.14-28.53,18.25,4.1,17.36,8.89c-1.19,6.39-13.74,22.06-13.74,22.06l-7.75-6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.49,361s9.78-11.29,31.86-19.82c0,0-5.72-1.75-7-4.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.99,
    y1: 395.55,
    x2: 279.05,
    y2: 428.01,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,302s4,6.75,20.47,6.13a25.51,25.51,0,0,0-11.24-7C359.57,299.33,357.07,302,357.07,302Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,304.71s3.82-5.92,7.32-7.11,13.78-1.29,15.37-1.33,29.84,7.14,43.1,11.56L357.8,285.7l17.82,1.41s-.72,27-3.49,34.15-6.74,5.41-13.51,2.49c-26.63-11.47-42.23-19.46-43.68-19S293.17,304.71,293.17,304.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.35,272.84a16.62,16.62,0,0,0-.44,5.62c.79,6.92,4.16,23.54,4.16,23.54s16.61,2.37,20.47,6.13c0,0,2.74-22-2.84-33.17s-11.35-12.4-11.35-12.4c-3.65-.9-7,2.5-8.85,6.87",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4000000059604645
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.35,272.84a16.62,16.62,0,0,0-.44,5.62c.79,6.92,4.16,23.54,4.16,23.54s16.61,2.37,20.47,6.13c0,0,2.74-22-2.84-33.17s-11.35-12.4-11.35-12.4c-3.65-.9-7,2.5-8.85,6.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.55,281.4a22.08,22.08,0,0,0,8.5,4.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,281.4s6,11.34,13.58,13.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,368.75s1.11.84,1.56,3.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.08,372.62a7,7,0,0,1,4.89,2.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,361s3.2,1.62,2.51,6.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.63,364.9s4.37,2.59,4.68,4.91",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.28,336.92s9.73,1.36,11.91,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,277.39a18.39,18.39,0,0,1-1-7.43,21.83,21.83,0,0,1,.27-2.55l-1.69-2.68-2.17-3.45,2.51-10s16,3.08,17.2,7.54S324.36,277.39,324.36,277.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.34,270a21.83,21.83,0,0,1,.27-2.55l-1.69-2.68a12.79,12.79,0,0,0,7.81-4.38A9.83,9.83,0,0,1,323.34,270Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,277.39a18.39,18.39,0,0,1-1-7.43,21.83,21.83,0,0,1,.27-2.55l-1.69-2.68-2.17-3.45,2.51-10s16,3.08,17.2,7.54S324.36,277.39,324.36,277.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,252.12c5-13,1.68-35.13-22.32-30.89C298,223.73,296.3,240.75,301,248.31s-.29,7.8,6.78,13.4c2.87,2.27,5.18,6.12,8.6,6.37,4.07.28,9.28-3.57,13.17-7.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.75,248.31s3.54-3.22,7.75-1.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.12,248.31a6.24,6.24,0,0,0-4.59-3.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.46,253s-.51,2.59-1.18,5.21,4.2,1.19,4,.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.79,262.27a10.63,10.63,0,0,0,5.27-3.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68,251.6a1.1,1.1,0,0,1-.42,1.5,1.11,1.11,0,0,1-1.5-.43,1,1,0,0,1-.14-.51,1.1,1.1,0,0,1,.42-1.5,1.11,1.11,0,0,1,1.5.43A1,1,0,0,1,315.68,251.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,251.38c.2.72.06,1.4-.32,1.5s-.85-.4-1-1.13-.05-1.4.33-1.5S304.78,250.65,305,251.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,234.92s-3.72,9.73-12.92,9.51c0,0,3.19-2.43,4.07-4.75,0,0-7.08,7-14.15,3.44S293,223,303.85,216.46s21.95-4.79,25.71,1.46c0,0,7.6-.7,10.95,10.47,3,10-1.8,25.16-6.49,25.33-7.27.27-8.73-7.62-8.73-7.62A20.81,20.81,0,0,1,319.6,234.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.57,252.17s-.23-9.18,5-8.07,1.44,11.72-2.49,11.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.16,
    y: 303.71,
    width: 83.89,
    height: 6.07,
    rx: 1.63,
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.79 425.86 77.78 425.86 81.34 456.95 108.23 456.95 111.79 425.86",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,404.22s-14.85,1.17-15.47,12.13C100.35,416.35,115.39,423.27,115.82,404.22Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.44,406.94s-8.3-11.22-21.71-5.47C64.73,401.47,72.92,415,86.44,406.94Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.87,371.52s-2.39,21.58,17.26,15.64C83.13,387.16,76.89,371.29,65.87,371.52Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,359.5s-15.54,8.38-4.11,21.1C85.88,380.6,96.77,371.51,90,359.5Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,378.79s-16.9-1.71-16.9,13.93C92.21,392.72,109.11,393.39,109.11,378.79Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,438.67s7.7-16.16.31-32.62-9.9-30.33-6-40.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.56,383S93.43,387,90,397.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,380.15s5.85,8,15.76,7.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,403.77s16.2,4.66,22.64,3.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,409.15s-7.25,8-14.53,7.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.32,
    y: 425.17,
    width: 36.93,
    height: 4.39,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,387.36s0-4.31,6.53-4.9,7.46,5.7,7.46,5.7h-2.25s.05-3.77-4.75-4.06-4.62,4.06-4.62,4.06Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.27,391.93c5,1.07,7.88,21.34,14.61,26.5s38.46,4.05,42.05,0-3.43-26.79-8.53-30.27-8.73-.1-23.08-1.69C377.05,384.1,373.27,391.93,373.27,391.93Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s3.12,8.41,4.75,9.7,36.16,1.29,40-1.83-1.42-8.76-5.11-9.06C429.93,427.6,405.74,430.42,390.3,428.79Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fill: "#0096C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427l-6.69,1.34s-6.38,4.9-3.56,6.53S379,432.5,379.16,427Z",
    style: {
      fill: "#0096C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex);
export default __webpack_public_path__ + "static/media/index.72ebe7e0a9ff09fce2f52a6412990e6b.svg";
export { ForwardRef as ReactComponent };